import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { FiCheck } from '@react-icons/all-files/fi/FiCheck';
import React from 'react';
export const Check = ({ size, color }) => <FaCheck style={{ fontSize: size, color }}/>;
export const CheckLight = ({ size, color }) => (<FiCheck style={{ fontSize: size, color }}/>);
